import React, { useEffect, useState } from "react";
import { useSession } from "../session/Context";
import api from "../Api";
import { toast } from "react-toastify";
import LeftPanel from "../LeftPanel/LeftPanel";
import { Navigate, useNavigate } from "react-router-dom";

export default function Onboarding(props: any) {
  const navigate = useNavigate();
  const [messageHeading, setMessageHeading] = useState("");
  const [messageDesc, setMessageDesc] = useState("");
  const { email, onboarding, notifications } = useSession();
  const [onboardType, setOnboardType] = useState(0);
  const [brandData, setBrandData] = useState({
    id: "",
    name: "",
    new: true,
  });

  useEffect(() => {
    if (props.sessionStatus === "ERROR") {
      console.log("session is in error");
    }
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      notifications.map((el) => {
        if (el.data && el.data.title === "Onboarding request accepted") {
          toast.success("Onboarding request accepted.");
          window.location.reload();
        }
      });
    }
  }, [notifications]);

  const changeBrandData = (name: string, data: any): void => {
    setBrandData({ ...brandData, [name]: data });
  };

  const onNewBrand = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    api("/api/v1/brand", {
      method: "POST",
      body: JSON.stringify(brandData),
    })
      .then((response) => {
        if (response) {
          window.location.href = "/";
        } else {
          setMessageHeading("Your registration is waiting for approval.");
          setMessageDesc(
            "You will be notified by email when your request is resolved."
          );
          toast.success("Registered a new company", { theme: "colored" });
        }
      })
      .catch((reason) => {
        toast.error("Error " + reason, { theme: "colored" });
      });
  };

  const onJoinBrand = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
  };

  return (
    <>
      <main>
        {/* {(onboardType == 0 || onboarding) && (<LeftPanel heading="Issuer" fontSize="120px" />)}

{onboardType == 1 && <LeftPanel heading="Register a new company" />}

{onboardType == 2 && <LeftPanel heading="Join registered company" />} */}
        <div className="mobile-pro">
          <div className="login">
            <img src="img/issue-icon-default.svg" />
            <h2>Onboarding</h2>
          </div>
        </div>

        <div className="col-content">
          <div className="notifications-container">
            <div className="onboarding">
              {messageHeading === "" && !onboarding ? (
                <>
                  {onboardType == 0 && (
                    <>
                      <div className="messages no-mobile-pro">
                        <h2>I would like to </h2>
                      </div>

                      <div className="onboarding-btn">
                        <button
                          className="btn btn-primary onboarding"
                          onClick={() => {
                            setOnboardType(1);
                          }}
                        >
                          Register a company
                        </button>
                      </div>

                      <div className="onboarding-btn">
                        <button
                          className="btn btn-primary onboarding"
                          onClick={() => {
                            //setOnboardType(2);
                            toast.error("This feature is coming soon.");
                          }}
                        >
                          Join already registered company
                        </button>
                      </div>
                    </>
                  )}

                  {onboardType == 1 && (
                    <>
                      <h2>Register a new company</h2>
                      <form className="form" onSubmit={onNewBrand}>
                        <div>
                          <label>
                            <span className="requiredMark">*</span> Company name{" "}
                          </label>
                          <input
                            type="text"
                            className="issuer-form"
                            name="name"
                            maxLength={140}
                            placeholder="Name of the company"
                            value={brandData.name}
                            onChange={(event) => {
                              changeBrandData("name", event.target.value);
                            }}
                            required
                          ></input>
                        </div>

                        <button
                          className="btn btn-primary onboarding"
                          type="submit"
                        >
                          Register
                        </button>
                        <button
                          className="btn btn-secondary onboarding"
                          onClick={() => {
                            setOnboardType(0);
                            changeBrandData("name", "");
                          }}
                        >
                          Back
                        </button>
                      </form>
                    </>
                  )}

                  {onboardType == 2 && (
                    <>
                      <h2>Join a company</h2>
                      <br></br>
                      <form className="form" onSubmit={onJoinBrand}>
                        <div>
                          <label>
                            <span className="requiredMark">*</span> Company
                            identifier{" "}
                          </label>
                          <input
                            required
                            className="issuer-form"
                            type="text"
                            maxLength={140}
                            name="id"
                            placeholder="Company ID"
                          ></input>
                        </div>

                        <button
                          className="btn btn-primary onboarding"
                          type={"submit"}
                        >
                          Join
                        </button>
                        <button
                          className="btn btn-secondary onboarding"
                          onClick={() => {
                            setOnboardType(0);
                          }}
                        >
                          Back
                        </button>
                      </form>
                    </>
                  )}
                </>
              ) : (
                <>
                  <h2 className="light-heading">{messageHeading}</h2>
                  <p>{messageDesc}</p>
                </>
              )}

              {onboarding && (
                <>
                  <h2 className="light-heading">
                    Your registration is waiting for approval.
                  </h2>
                  <p>
                    You will be notified by email when your request is resolved.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
/*
 */
